import { useQuery } from '@tanstack/react-query';
import { fetchAuditLogs, type AuditLogsQuery } from '@/services/api/audit.api';

export function useAuditLogs(query: AuditLogsQuery, enabled = true) {
  return useQuery({
    queryKey: ['audit-logs', query],
    queryFn: () => fetchAuditLogs(query),
    staleTime: 30_000,
    enabled,
  });
}
